module.exports = __webpack_public_path__ + "img/logo.d33e63a4.png";